module.exports = __webpack_public_path__ + "assets/img/5e49d73a555eb4979508822fcdd53071.png";